import React from 'react';
import { Eye } from 'lucide-react';

interface Tour {
  id: string;
  name: string;
  thumbnail: string;
  embedUrl: string;
}

const tours: Tour[] = [
  {
    id: 'grand-duo-64a',
    name: 'Grand Duo - 64A',
    thumbnail: '/lovable-uploads/tour-grand-duo-64a.png',
    embedUrl: 'https://kuula.co/share/collection/7Hbbx?logo=0&info=0&fs=1&vr=1&zoom=1&sd=1&initload=0&thumbs=-1&alpha=0.60&inst=0'
  }
];

const ToursPage: React.FC = () => {
  const handleTourClick = (tourId: string) => {
    window.open(`/tour-view/${tourId}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-foreground mb-8 text-center">
          Tours Virtuais 360°
        </h1>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {tours.map((tour) => (
            <div
              key={tour.id}
              onClick={() => handleTourClick(tour.id)}
              className="group cursor-pointer rounded-xl overflow-hidden bg-card border border-border shadow-sm hover:shadow-lg transition-all duration-300"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={tour.thumbnail}
                  alt={tour.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="bg-white/90 rounded-full p-3">
                    <Eye className="w-6 h-6 text-primary" />
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground text-center">
                  {tour.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ToursPage;
